export { Modal, ModalContent } from './Modal';
export type { ModalProps, ModalContentProps } from './Modal';
